<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-dialog modal-dialog-scrollable" role="document"
                     :class="this.size_class">
                    <div class="modal-content w-100">
                        <div class="modal-header" v-if="this.show_title">
                            <slot name="header">
                                <h5 class="modal-title">Title</h5>
                            </slot>
                            <button type="button" class="close" aria-label="Close" @click="$emit('close')"
                                    v-if="this.header_close_icon">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <slot name="body">
                            </slot>
                        </div>
                        <div class="modal-footer">
                            <slot name="footer">
                                <button type="button" class="btn btn-primary" @click="$emit('close')">
                                    {{$t('chiudi')}}
                                </button>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: ['showTitle', 'size', 'headerCloseIcon'],
        data: function () {
            return {
                show_title: this.showTitle,
                header_close_icon: [true, false].includes(this.headerCloseIcon) ? this.headerCloseIcon : true
            }
        },
        created() {
            $('body').addClass('modal-open').css({
                'padding-right': `${this._getScrollbarWidth()}px`
            });
        },
        destroyed() {
            setTimeout(() => {
                $('body').removeClass('modal-open').css({
                    'padding-right': ''
                });
            }, 200);
        },
        computed: {
            //large, medium, small
            size_class: function () {
                switch (this.size) {
                    case 'medium':
                        return {'modal-md': true};
                    case 'small':
                        return {'modal-sm': true};
                    case 'large':
                    default:
                        return {'modal-lg': true};
                }
            }
        },
        methods: {
            _getScrollbarWidth() { // thx d.walsh
                const scrollDiv = document.createElement('div');
                scrollDiv.className = 'modal-scrollbar-measure';
                document.body.appendChild(scrollDiv);
                const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
                document.body.removeChild(scrollDiv);
                return scrollbarWidth;
            }
        }
    }
</script>
